function Line() {
    return (

        <div className="w-full flex items-center border-b border-t justify-center gap-4 py-12">
            {/* Left line */}
            <div className="flex-1 relative">
                <div className="absolute w-1/2  right-0 h-[1px] bg-gray-200"></div>
                <div className="absolute left-1/2 w-2 h-2 rounded-full bg-white border -translate-y-1"></div>
            </div>

            {/* Center icon */}
            <div className="w-8 h-8 flex items-center justify-center rounded-full">
                <img
                    src='/howitworks/graph.svg'
                    alt="Divider icon"
                    className="w-8 h-8 object-contain"
                />
            </div>

            {/* Right line */}
            <div className="flex-1 relative">
                <div className="absolute w-1/2 h-[1px] bg-gray-200"></div>
                <div className="absolute left-1/2 w-2 h-2 rounded-full bg-white border -translate-y-1"></div>
            </div>
        </div>
    )
}
export default Line